/* xs-scope-css.js v1.2 (2026-09-25) — 修 v1.0/1.1 的选择器改写(老板 0925 手机端: VK cocoon 等 A+ 整块失去样式/不自适应):
   ① v1.1 在选择器前加「.xs-scope-N 空格」= 要求规则里的元素都在容器「里面」; 但 VK 系列 A+ 的 <style> 就放在 .vk-a-plus-scope 里,
     容器本身就是 .vk-a-plus-scope → 「.xs-scope-N .vk-a-plus-scope .hero」永远匹配不到 → 整个 A+(桌面+手机)全部裸奔。
     同理写了祖先上下文的规则(.template-product .x、#shopify-section-… .x)也全失效。
     v1.2 改为只约束「主体」(最右那个复合选择器): S → S:is(.xs-scope-N *)(主体带类/ID/属性时 :is(.xs-scope-N, .xs-scope-N *),允许命中容器本身),
     祖先部分照原样在整页匹配 → 规则只作用于容器内元素, 语义与原 CSS 一致, 特异性仍 +1 类(同 v1.1)。
   ② @container / @layer{} / @scope / @starting-style 里的规则 v1.1 不递归 → 没加前缀, 特异性低于已加前缀的基础规则 → 容器查询的手机/桌面覆盖失效(VK 618 款 A+ 用 @container)。v1.2 全部递归。
   ③ 逗号按顶层切分(:is()/:not()/属性值里的逗号不再被切坏); 伪元素(::before / :after 等)前插入; 转义字符安全。
   ④ 已处理标记改为 WeakSet(按 sheet 对象): 主题把描述整块搬位置/克隆/重写文本时浏览器按原文重建 sheet, v1.1 因 data-xs-scoped 属性还在而跳过 →
     整段 A+ CSS 又变全局(实测 RD 产品页 rd 主题约 19s 时搬动主区, .pd 系列描述的 body{padding:40px 20px} 漏到整页, 手机整页被挤窄 40px)。
     v1.2 新 sheet 重新处理, 且 MutationObserver 发现新插入的 <style> 立即处理(下一帧绘制前), 其余变动仍 100ms 去抖。
   保留: v1.1 body/html/:root 上 overflow* 留在页面级; :root/html/body 映射到容器(变量可用); @keyframes/@font-face/@import 不动; 零依赖, 幂等。
   不支持 :is() 的老浏览器退回 v1.0 前缀法(并对「首个复合选择器就是容器本身」的情况改为把类拼到它上面)。 */
(function () {
  'use strict';
  var HOSTS = '.vk-a-plus-scope,.xs-aplus,.product-single__description,.product__description,.product-description,.rte,.product-block--description,.product-info__description,[class*="description"] .rte';
  var n = 0;
  var ROOT_RE = /^(:root|html|body)$/i;
  var LEGACY_PE = /^:(before|after|first-line|first-letter)(?![\w-])/i;
  var GROUP_RE = /^CSS(Media|Supports|Container|LayerBlock|Scope|StartingStyle|Document|MozDocument)Rule$/;
  var IS = false; try { IS = !!(window.CSS && CSS.supports && CSS.supports('selector(:is(a *))')); } catch (e) { }
  var done = typeof WeakSet === 'function' ? new WeakSet() : null;

  // 顶层扫描: 跳过转义、引号、() [] 内部; cb(i, ch) 返回 true 则停止
  function scan(s, cb) {
    var depth = 0, q = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i);
      if (c === '\\') { var m = /^[0-9a-fA-F]{1,6}[ \t\n\r\f]?/.exec(s.slice(i + 1, i + 8)); i += m ? m[0].length : 1; continue; } // 转义(含 \31 23 这类十六进制+空格)
      if (q) { if (c === q) q = ''; continue; }
      if (c === '"' || c === "'") { q = c; continue; }
      if (c === '(' || c === '[') { if (depth === 0 && cb(i, c, 0)) return i; depth++; continue; }
      if (c === ')' || c === ']') { depth--; continue; }
      if (depth === 0 && cb(i, c, 0)) return i;
    }
    return -1;
  }
  function splitTop(sel) {
    var out = [], start = 0;
    scan(sel, function (i, c) { if (c === ',') { out.push(sel.slice(start, i)); start = i + 1; } return false; });
    out.push(sel.slice(start));
    return out;
  }
  function isComb(c) { return c === ' ' || c === '>' || c === '+' || c === '~' || c === '\t' || c === '\n' || c === '\r' || c === '\f'; }
  function firstCompoundEnd(s) { var e = scan(s, function (i, c) { return isComb(c); }); return e < 0 ? s.length : e; }
  function lastCompoundStart(s) { var st = 0; scan(s, function (i, c) { if (isComb(c)) st = i + 1; return false; }); return st; }
  function pseudoElIndex(comp) {
    return scan(comp, function (i, c) { return c === ':' && (comp.charAt(i + 1) === ':' || LEGACY_PE.test(comp.slice(i))); });
  }
  function hasKey(comp) { return scan(comp, function (i, c) { return c === '.' || c === '#' || c === '['; }) >= 0; }
  var clsRe = {};
  function hasCls(s, cls) { return (clsRe[cls] || (clsRe[cls] = new RegExp('\\.' + cls + '(?![\\w-])'))).test(s); }
  // 去掉开头的 html / body / :root 链(只认后接空格或 > 的), 返回剩余部分与连接符
  function stripRoot(s) {
    var cnt = 0, comb = '', rest = s;
    while (rest) {
      var e = firstCompoundEnd(rest);
      if (!ROOT_RE.test(rest.slice(0, e))) break;
      var j = e, cm = '';
      while (j < rest.length && isComb(rest.charAt(j))) { if (!/\s/.test(rest.charAt(j))) cm += rest.charAt(j); j++; }
      cnt++; comb = cm || (j > e ? ' ' : ''); rest = rest.slice(j);
      if (comb !== ' ' && comb !== '>') break;
    }
    return { n: cnt, comb: comb, rest: rest };
  }
  function constrain(s, cls) {
    var st = lastCompoundStart(s), comp = s.slice(st), pe = pseudoElIndex(comp);
    var head = pe < 0 ? comp : comp.slice(0, pe), tail = pe < 0 ? '' : comp.slice(pe), c = '.' + cls;
    return s.slice(0, st) + head + (hasKey(head) ? ':is(' + c + ', ' + c + ' *)' : ':is(' + c + ' *)') + tail;
  }
  function scopeOne(s, cls, host) {
    var t = s.trim(); if (!t) return t;
    if (hasCls(t, cls)) return t;
    var r = stripRoot(t);
    if (r.n) {
      if (!r.rest) return '.' + cls;                       // :root / html / body → 容器本身
      if (r.comb === '>') return '.' + cls + ' > ' + r.rest; // body > x → 容器 > x
      t = r.rest;                                            // body x → x(再约束主体)
    }
    if (IS) return constrain(t, cls);
    // 老浏览器: v1.0 前缀法; 首个复合选择器就是容器本身时把类拼上去
    var e = firstCompoundEnd(t), head = t.slice(0, e);
    if (pseudoElIndex(head) < 0) { try { if (host && host.matches(head)) return head + '.' + cls + t.slice(e); } catch (x) { } }
    return '.' + cls + ' ' + t;
  }
  function scopeSel(sel, cls, host) {
    return splitTop(sel).map(function (s) { return scopeOne(s, cls, host); }).join(', ');
  }
  var OVF = ['overflow', 'overflow-x', 'overflow-y', 'overflow-inline', 'overflow-block'];
  function liftOverflow(r) {
    // v1.1: 选择器里裸写的 body/html/:root 上的 overflow* 是给整页用的(挣脱块常配 body{overflow-x:hidden}), 改写到容器上会把 100vw 挣脱块裁掉 → 抽出来原样留在页面级
    var bare = splitTop(r.selectorText).map(function (s) { return s.trim(); }).filter(function (s) { return ROOT_RE.test(s); });
    if (!bare.length) return null;
    var decl = '';
    for (var i = 0; i < OVF.length; i++) {
      var v = r.style.getPropertyValue(OVF[i]);
      if (v) { decl += OVF[i] + ':' + v + (r.style.getPropertyPriority(OVF[i]) ? ' !important' : '') + ';'; r.style.removeProperty(OVF[i]); }
    }
    return decl ? bare.join(',') + '{' + decl + '}' : null;
  }
  function isGroup(r) {
    if (r.type === 4 || r.type === 12) return true; // @media / @supports
    var nm = r.constructor && r.constructor.name;
    return !!(nm && GROUP_RE.test(nm));             // @container / @layer{} / @scope / @starting-style / @document
  }
  function scopeRules(rules, cls, parent, host) {
    var lifted = [];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      try {
        if (r.type === 1 && r.selectorText) {
          var lf = liftOverflow(r); if (lf) lifted.push(lf);
          var old = r.selectorText, ns = scopeSel(old, cls, host);
          if (ns !== old) {
            r.selectorText = ns;
            if (r.selectorText === old && IS) { IS = false; r.selectorText = scopeSel(old, cls, host); IS = true; } // 浏览器拒收(:is 不支持) → 前缀法
          }
          // 嵌套规则(CSS nesting)相对父选择器, 父已约束 → 不再递归
        } else if (r.cssRules && isGroup(r)) scopeRules(r.cssRules, cls, r, host);
        // @keyframes / @font-face / @import / @page / @property … 不动
      } catch (e) { }
    }
    // 循环结束后再追加(追加在末尾, 不会被本轮再改写)
    for (var j = 0; j < lifted.length; j++) { try { parent.insertRule(lifted[j], parent.cssRules.length); } catch (e) { } }
  }
  function run() {
    var hs = document.querySelectorAll('[data-xs-scope]'); // 主题改写 className 后把作用域类补回
    for (var k = 0; k < hs.length; k++) { var c0 = hs[k].getAttribute('data-xs-scope'); if (c0 && !hs[k].classList.contains(c0)) hs[k].classList.add(c0); }
    var styles = document.querySelectorAll('style');
    for (var i = 0; i < styles.length; i++) {
      var st = styles[i], sh = st.sheet;
      if (!sh) continue;
      if (done ? done.has(sh) : st.hasAttribute('data-xs-scoped')) continue;
      var host = st.closest ? st.closest(HOSTS) : null;
      if (!host || host.closest('head')) continue;
      var cls = host.getAttribute('data-xs-scope');
      if (!cls) { cls = 'xs-scope-' + (++n); host.setAttribute('data-xs-scope', cls); }
      if (!host.classList.contains(cls)) host.classList.add(cls);
      try { if (sh.cssRules) { scopeRules(sh.cssRules, cls, sh, host); if (done) done.add(sh); st.setAttribute('data-xs-scoped', '1'); } } catch (e) { }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 50); });
  if (window.MutationObserver) {
    // 新插入/被搬动的 <style>(主题把描述整块搬位置时 sheet 会按原文重建)立即重处理, 在下一帧绘制前完成, 不闪全局样式; 其余变动照旧 100ms 去抖
    var t; new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { var a = ms[i].addedNodes; for (var j = 0; j < a.length; j++) { var nd = a[j]; if (nd.nodeType === 1 && (nd.tagName === 'STYLE' || nd.tagName === 'style' || (nd.getElementsByTagName && nd.getElementsByTagName('style').length))) { clearTimeout(t); run(); return; } } }
      clearTimeout(t); t = setTimeout(run, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.__xsScopeCss = { run: run, v: '1.2' };
})();
